<template>
  <van-nav-bar fixed @click-left="onClickLeft" @click-right="onClickRight">
    <template #title>
      <div>{{title}}</div>
    </template>
    <template #left v-if="showBack">
      <van-icon name="arrow-left"  :color="fontColor" size="18" />
    </template>
    <slot name="right" slot="right" />
    <template #right>
      <van-icon v-if="showHome" name="cross" size="18" />
      <span class="rightText" v-if="rightText">{{rightText}}</span>
      <van-icon :name="righyIcon" size="20" v-if="righyIcon" />
    </template>
  </van-nav-bar>
</template>

<script>
export default {
  name: 'Header',
  props: {
    title: {
      type: String,
      default: ''
    },
    bgColor: {
      type: String,
      default: '#00545e'
    },
    fontColor: {
      type: String,
      default: '#fff'
    },
    showBack: {
      type: Boolean,
      default: true
    },
    showHome: {
      type: Boolean,
      default: false
    },
    leftHandler: {
      type: Function,
      default: null
    },
    rightHandler: {
      type: Function,
      default: null
    },
    righyIcon: {
      type: String,
      default: null
    },
    rightText: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: null
    },
  },
  methods: {
    onClickLeft () {
      if (this.leftHandler) {
        this.leftHandler.apply()
      } else {
        this.$router.go(-1)
      }
    },
    onClickRight () {
      if (this.rightHandler) {
        this.rightHandler.apply()
      } else {
        console.log('default right click event')
      }
    }
  }
}
</script>

<style  scoped lang="less">
// .van-nav-bar{
//   color: black;
// }
// .van-nav-bar{
//   color: black;
// }
.rightText{
  color: #fff;
}
</style>
